export default "__VITE_ASSET__BM8Scn1N__"